<template>
<div class="status-as-icon">
  <font-awesome-icon
    v-if="value==='published'"
    title="publié"
    icon="check-circle"
    class="published"
    />
  <font-awesome-icon
    v-if="value==='published_with_draft' || value==='publishedWithDraft'"
    title="publié avec un brouillon en cours"
    icon="check-circle"
    class="published"
    />
  <font-awesome-icon
    v-if="value==='published_with_draft_in_validation' || value === 'publishedWithDraftInValidation'"
    title="publié avec brouillon en attente de validation"
    icon="check-circle"
    class="published-with-draft"
    />
  <font-awesome-icon
    v-if="value==='inValidation'"
    title="en validation"
    icon="pencil"
    class="in-validation"
    />
  <font-awesome-icon
    v-if="value==='unpublished' || value==='archived' || value==='closed'"
    title="non publié"
    icon="times-circle"
    class="unpublished"
    />
  <font-awesome-icon
    v-if="value==='draft' || value==='initial'"
    title="brouillon"
    icon="edit"
    class="draft"
    />
</div>
</template>

<script>
export default {
    name: 'StatusAsIcon',
    components: {
    },
    props: [
        'value',
    ],
    data: function() {
        return {
        };
    },
    methods: {
    },
};
</script>

<style lang="stylus" scoped>
@require '../../../stylesheet/typography'
@require '../../../stylesheet/variables'

:deep(.published)
    color: success-color

:deep(.published-with-draft)
:deep(.draft)
:deep(.in-validation)
    color: warning-color

:deep(.unpublished)
    color: error-color
</style>
